// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InvestorHero-module--wrapper--391Qt","content":"InvestorHero-module--content--UNB5C"};